'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SET_FORM_MODE: 'CUSTOMER_SET_FORM_MODE',

    DISCARD_DELIVERY_ADDRESS: 'CUSTOMER_DISCARD_DELIVERY_ADDRESS',
    EDIT_DELIVERY_ADDRESS: 'CUSTOMER_EDIT_DELIVERY_ADDRESS',
    SELECT_DELIVERY_ADDRESS: 'CUSTOMER_SELECT_DELIVERY_ADDRESS',
    SHOW_DELIVERY_ADDRESSES: 'SHOW_DELIVERY_ADDRESSES',

    CONTACT_CHANGE: 'CUSTOMER_CONTACT_CHANGE',
    CONTACT_SAVING: 'CUSTOMER_CONTACT_SAVING',
    CONTACT_SAVED: 'CUSTOMER_CONTACT_SAVED',
    CONTACT_INVALID: 'CUSTOMER_CONTACT_INVALID',
    CONTACT_DISPLAY_ERRORS: 'CUSTOMER_CONTACT_DISPLAY_ERRORS',

    CUSTOMER_INVALID: 'CUSTOMER_INVALID'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customer/action-types.js
// module id = 443
// module chunks = 0 2